export const MIXPANEL_TOKEN_PRODUCTION_ENC =
  "U2FsdGVkX19D4ifLISl2yb0hJbhUxhfveyL0RQyTQmdgQXsqDYHC1U3gbmze9iPXyu3hKnfxTg2NAGoU53/1PQ==";
export const MIXPANEL_TOKEN_STAGING_ENC =
  "U2FsdGVkX18Z5oe4myCshnhaS5a12jcltFuvi96m3VaZNAk4dIsw3Fwb27KE5853InhZINLjL1h6Y6ZIa8ZAqw==";
export const GOOGLE_CLIENT_ID_ENC =
  "U2FsdGVkX1/2SHw8eCZu5/TsZuItCFOVgBKDsfwmNgaWcWD6RFlK1C6bv+8zoAWEAIeAfTDpxU6lGe+GwScd3I74D7f2/lfHbDPrQdPHmjDDezSABVVzLHgnSLPV5cqT";
export const REACT_APP_STRIPE_PUBLISHABLE_STAGING_KEY_ENC =
  "U2FsdGVkX19gnrT965rT+/uLvkP1ntJBPT4dPs284yT1hhLDIzcKpERIap8axFyt7MC+hiOIVocjyUJ2ZkjKN6rxEG/utYs1T1Hs4vH9kabaxdDIRz2UL8iMblpEvbrjB7WHSgTIVLFdtE41yp6TJDdCzR11eu0MaKSBTx4RHfI=";
export const REACT_APP_STRIPE_PUBLISHABLE_PRODUCTION_KEY_ENC =
  "U2FsdGVkX1/fO0y6vJLTOUUqGqoKymxqK+MPQycWewE3nUvuMo677B4Fgdj11r9eBFr5KzTKUZdO8mX5pyObNwU0KjIGtmBj8TMvuiWfWPktjHUxzzcSIvTYxP+bZ2JQNA8OkljOmtmIhxDxHNF+l8TsREG9ZYoqX5cur6CmOAM=";
export const REACT_APP_SPLIT_KEY_ENC =
  "U2FsdGVkX18nSA2jfQ6Hqtao0QXO6tWqfVPG6z1/EBH6BJVQCZzoYdw5al/jkUApMbEx0flaZh+LtOZg2CoD5w==";
